<template>
  <div class="doencas-details">
    <page-header :title="title" />
    <page-section :group-label="$t('Cronicas')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Doencas')"
            :value="tag.doencas | toPT_BRCapitalize"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('doencas')
            "
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Alergias')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Alergias')"
            :value="tag.alergias | toPT_BRCapitalize"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('alergias')
            "
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Doencas") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Doencas"),
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
  },
};
</script>

<style scoped></style>
